import React from 'react';
import { Search as LucideSearch } from 'lucide-react';

interface SearchProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Search: React.FC<SearchProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideSearch width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default Search;
